import React from "react";
import { RouteObject } from "../../interfaces/navigation";
import { Navigate } from "react-router-dom";

const EntryPoint = React.lazy(() => import("../../containers/Search/SearchContainer"));

export const searchRoutes: RouteObject[] = [
    {
        title: "Search Redirect",
        path: "/buscar",
        component: <Navigate to="/buscar/autos/usados" replace />
    },
    {
        title: "Search Autos Redirect",
        path: "/buscar/autos",
        component: <Navigate to="/buscar/autos/usados" replace />
    },
    {
        title: "Search with Filters",
        path: "/buscar/autos/usados/*",
        component: <EntryPoint/>
    },
    {
        title: "Search with Filters",
        path: "/buscar/autos/nuevos/*",
        component: <EntryPoint/>
    }
];